import { Checkbox, TableDataCell } from "@digital-services/ui";

import { ApplicationJsonModel } from "@applications/models/ApplicationJsonModel";
import { ApplicationUser } from "@applications/models/ApplicationUser";
import { UserState } from "@organization/models/EssentialUser";
import EditApplicationUserButton from "@users/applicationuser/components/EditApplicationUserButton";
import { UserStatusIcon } from "@users/components/UserStatusIcon";

import { useUserContext } from "@hooks/useUserContext";

interface Props {
  application: ApplicationJsonModel;
  associatedUser: ApplicationUser;
  isChecked: boolean;
  toggleRowCheckbox: (val: ApplicationUser) => void;
}

export const ApplicationUserDataRow = (props: Props) => {
  const { application, associatedUser, isChecked, toggleRowCheckbox } = props;

  const { user: currentUser } = useUserContext();

  const renderAColumn = (userId: string, columnName: string, value: string) => {
    return (
      <TableDataCell>
        <div
          data-testid={`application-${application.id}-user-${userId}-${columnName}`}
        >
          {value}
        </div>
      </TableDataCell>
    );
  };

  const renderStatusColumn = (userId: string, state: UserState) => {
    return (
      <TableDataCell>
        <div
          className="flex gap-2"
          data-testid={`application-${application.id}-user-${userId}-status`}
        >
          <UserStatusIcon state={state} />
          {state}
        </div>
      </TableDataCell>
    );
  };

  const renderSelectionColumn = (user: ApplicationUser) => {
    if (!currentUser.isAdministrator) return "";

    return (
      <TableDataCell className="w-1">
        <div data-testid={user.userId}>
          <Checkbox
            id={application.id + "_" + user.userId}
            data-testid={`checkbox-${application.id}-${user.userId}`}
            label={""} // "" is IMPORTANT here
            variant="alternative"
            checked={isChecked}
            onChange={() => toggleRowCheckbox(user)}
          />
        </div>
      </TableDataCell>
    );
  };

  return (
    <tr>
      {currentUser.isAdministrator && renderSelectionColumn(associatedUser)}
      {renderAColumn(
        associatedUser.userId,
        "displayName",
        associatedUser.displayName
      )}
      {renderAColumn(associatedUser.userId, "email", associatedUser.email)}
      {renderAColumn(
        associatedUser.userId,
        "roles",
        associatedUser.applicationRoles.join(", ")
      )}
      {renderStatusColumn(associatedUser.userId, associatedUser.state)}

      <TableDataCell>
        <div className="grid grid-cols-2">
          <EditApplicationUserButton
            applicationId={application.id}
            user={associatedUser}
          />
        </div>
      </TableDataCell>
    </tr>
  );
};
